// Auth API response types
import { StandardResponseSchema, type StandardResponse } from "@/helpers/types";

// Verify free user response - uses StandardResponse { ok: boolean }
export const VerifyFreeUserResponseSchema = StandardResponseSchema;
export type VerifyFreeUserResponse = StandardResponse;

// Login error response
export interface LoginErrorResponse {
  detail: string;
}

// Reset password request
export interface ResetPasswordRequest {
  password: string;
  token: string;
}

// Register invite request
export interface RegisterInviteRequest {
  name: string;
  password: string;
  token: string;
}

// Register SSO request
export interface RegisterSSORequest {
  firstName: string;
  lastName: string;
}

// Login request
export interface LoginRequest {
  email: string;
  password: string;
}

// Forgot password request
export interface ForgotPasswordRequest {
  email: string;
}
